import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TabsData } from '@material-library';
import { PermissionActions, User } from '../../models';
import { UserService } from 'src/app/core/user.service';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../reducers';

@Component({
  selector: 'app-settings-nav-layout',
  templateUrl: './settings-nav-layout.component.html',
  styleUrls: ['./settings-nav-layout.component.scss']
})
export class SettingsNavLayoutComponent implements OnInit, OnDestroy {

  public navLinks: TabsData[] = [];

  private sub: Subscription;
  private routerSubscription: Subscription;
  public showCustomBranding: boolean;
  public permissionActions=PermissionActions;
  @Input() user: User;
  constructor(
    private store: Store<fromRoot.State>,
    private userService: UserService,
    private router: Router,
  ) { }

  ngOnInit(): void {

    this.sub = this.store
            .select(fromRoot.getAuthState)
            .subscribe((data) => {
                if (!data.authenticated) {
                    this.user = new User();
                    return;
                }
                if (data.user) {
                    this.user = data.user;
                    this.showCustomBranding = (this.user.has_whitelabel && !this.user.is_multi_child && !this.user.is_multi_admin) || (this.user.has_whitelabel && (this.user.is_multi_admin || this.userService.checkPermission(this.permissionActions.MANAGE_BILLING)));
                }
            });
    
    
    this.updateNavLinks()
    this.routerSubscription = this.router.events.subscribe((routeEvent) => {
      if (routeEvent instanceof NavigationEnd) {
        this.updateNavLinks();
      }
    });
  }

  ngOnDestroy() {
    if (this.sub) {
        this.sub.unsubscribe();
    }
    if (this.routerSubscription) {
        this.routerSubscription.unsubscribe();
    }
}

private updateNavLinks() {
  const commonLinks = [
    { label: 'Profile', activeLink: this.router.url === '/settings/profile' },
    { label: 'Account & billing', activeLink: new URL(this.router.url, document.location.href).pathname === '/settings/billing' || this.router.url === '/settings/billing/profile' },
    { label: 'Devices', activeLink: this.router.url === '/settings/devices'},
    { label: 'Security', activeLink: this.router.url === '/settings/security' },
    { label: 'Events', activeLink: this.router.url === '/settings/events' },
  ];

  const brandingIndex = 2; // Index to insert the branding tab
  this.navLinks = this.showCustomBranding
    ? [...commonLinks.slice(0, brandingIndex), 
       { label: 'Branding', activeLink: this.router.url === '/settings/branding'},
       ...commonLinks.slice(brandingIndex)]
    : commonLinks;
}


  handleTabClick = (event: TabsData) => {
    // Iterate through all tabs
    this.navLinks.forEach((tab) => {
      // Set activeLink to true for the selected tab and false for others
      tab.activeLink = tab.label === event.label;
    });

    switch (event.label) {
      case 'Profile':
        // Navigate to Profile route
        this.router.navigate(['/settings/profile']);
        break;
      case 'Account & billing':
        this.router.navigate(['/settings/billing']);
        break;
      case 'Branding':
        this.router.navigate(['/settings/branding']);
        break;
      case 'Devices':
        this.router.navigate(['/settings/devices']);
        break;
      case 'Security':
        this.router.navigate(['/settings/security']);
        break;
      case 'Events':
        this.router.navigate(['/settings/events']);
        break;
    }
  }
}
